import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

// „MusiKonzept vor Ort“: geplant, noch ohne Inhalte (Frage 292, Daniel 14.10.2026). Bis dahin ein Satz mit dem Weg
// zum Kontakt statt „Inhalt bald verfügbar“, und noindex, bis die Seite Inhalte hat.
const MusiKonzeptVorOrt = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>MusiKonzept vor Ort</title>
        <meta name="description" content="Workshops und Veranstaltungen von MusiKonzept vor Ort." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Header />
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto text-center space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold">MusiKonzept vor Ort</h1>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Du möchtest uns zu einer Veranstaltung, einem Fachtag oder einem Workshop bei dir einladen? Schreib uns,
              dann besprechen wir gemeinsam, was möglich ist. Unsere Online-Termine findest du unter{" "}
              <Link to="/termine" className="font-semibold text-[#227277] underline underline-offset-2">
                Termine
              </Link>
              .
            </p>
            <Link
              to="/kontakt"
              className="inline-flex min-h-[44px] items-center justify-center rounded-full bg-[#227277] px-6 text-sm font-bold text-white hover:bg-[#1D2934]"
            >
              Kontakt aufnehmen
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MusiKonzeptVorOrt;
